<template>
  <div>
    <!-- Button -->
    <div class="top-table-container">
      <el-input v-model="search" prefix-icon="el-icon-search" class="search" placeholder="Buscar por palabra clave..." />
      <el-button @click.prevent="formNuevo">Nuevo Producto</el-button>
    </div>

    <!-- Table -->
    <el-table empty-text="Sin Resultados" :data="productosData" border style="width: 100%">
      <el-table-column prop="id" width="50" label="ID" align="center"> </el-table-column>
      <el-table-column prop="nombre" label="Nombre" sortable></el-table-column>
      <el-table-column align="center" prop="multiplicable" label="Producto Principal" width="170">
        <template slot-scope="scope">
          <el-tag :type="scope.row.multiplicable == '1' ? 'success' : 'danger'" disable-tranSitions>
            <template v-if="scope.row.multiplicable == '1'">{{ "Si" }}</template>
            <template v-else>{{ "No" }}</template>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Acciones" width="220" align="center">
        <template slot-scope="scope">
          <el-button size="mini" icon="el-icon-edit" @click.prevent="formEditar(scope.$index, scope.row)">Editar</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click.prevent="eliminar(scope.$index, scope.row)">Eliminar</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="paginate">
      <el-pagination background layout="prev, pager, next" @current-change="paginate" :page-size="pageSize" :total="total"> </el-pagination>
    </div>

    <!-- Modal => Nuevo - Editar -->
    <el-dialog :title="tituloModal" :visible.sync="modal" width="35%" top="10vh" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form" label-position="top">
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item prop="id" label="ID" v-show="operacion == 'editar'">
              <el-input :disabled="true" v-model="form.id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="operacion == 'editar' ? 18 : 24">
            <el-form-item label="Nombre" prop="nombre">
              <el-input v-model="form.nombre" placeholder="Nombre del producto"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Producto multiplicable por metros" prop="multiplicable">
              <el-switch v-model="form.multiplicable" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.prevent="modal = false">{{ "Cancelar" }}</el-button>
        <el-button v-loading.fullscreen.lock="loading" type="primary" @click.prevent="guardar('form')">{{ accion }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "Productos",
  data() {
    return {
      modal: false,
      search: "",
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      operacion: "",
      accion: "",
      tituloModal: "",
      productos: [],
      producto: {
        id: "",
        nombre: "",
        multiplicable: false,
      },
      form: {
        id: "",
        nombre: "",
        multiplicable: false,
      },
      rules: {
        nombre: [{ required: true, message: "Este campo es requerido.", trigger: "blur" }],
      },
    };
  },
  created() {
    this.mostrar();
  },
  computed: {
    searching() {
      if (!this.search) {
        this.total = this.productos.length;
        return this.productos;
      }
      this.page = 1;
      return this.productos.filter(data => data.nombre.toLowerCase().includes(this.search.toLowerCase()));
    },
    productosData() {
      this.total = this.searching.length;
      return this.searching.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
    },
  },
  methods: {
    // MÉTODOS PARA EL CRUD
    mostrar() {
      axios
        .get("productos")
        .then(res => (this.productos = res.data))
        .catch(err => {
          console.log(err);
          this.$notify.error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: `No se ha podido mostrar la data, ah ocurrido un error inesperado`,
          });
        });
    },
    crear() {
      const datos = {
        nombre: this.form.nombre,
        multiplicable: this.form.multiplicable,
      };
      axios
        .post("productos", datos)
        .then(res => {
          if (res) {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
              this.$notify({
                title: "Éxito",
                dangerouslyUseHTMLString: true,
                message: `<strong>${datos.nombre}</strong> ha sido <strong>creada</strong> con exito!`,
                type: "success",
              });
              this.mostrar();
            }, 1500);
          }
        })
        .catch(err => {
          console.log(err);
          this.$notify.error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: `No se ha podido crear el producto, ah ocurrido un error inesperado`,
          });
        });
      this.producto.nombre = "";
    },
    editar() {
      const id = this.form.id;
      const datos = {
        nombre: this.form.nombre,
        multiplicable: this.form.multiplicable,
      };
      axios
        .put(`productos/${id}`, datos)
        .then(res => {
          if (res) {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
              this.$notify({
                title: "Éxito",
                dangerouslyUseHTMLString: true,
                message: `<strong>${datos.nombre}</strong> ha sido <strong>actualizada</strong> con exito!`,
                type: "success",
              });
              this.mostrar();
            }, 1500);
          }
        })
        .catch(err => {
          console.log(err);
          this.$notify.error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: `No se ha podido editar el producto, ah ocurrido un error inesperado`,
          });
        });
    },
    eliminar(_, data) {
      const id = data.id;
      this.$confirm("Esta seguro que desea eliminar este registro?", "Eliminar Producto", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(res => {
          if (res) {
            axios
              .delete(`productos/${id}`)
              .then(res => {
                if (res) {
                  this.loading = true;
                  setTimeout(() => {
                    this.loading = false;
                    this.$notify({
                      title: "Éxito",
                      dangerouslyUseHTMLString: true,
                      message: `<strong>${data.nombre}</strong> ha sido <strong>eliminada</strong> con exito!`,
                      type: "success",
                    });
                    this.mostrar();
                  }, 1500);
                }
              })
              .catch(err => {
                console.log(err);
                this.$notify.error({
                  title: "Error",
                  dangerouslyUseHTMLString: true,
                  message: `No se ha podido eliminar el producto, ah ocurrido un error inesperado`,
                });
              });
          }
        })
        .catch(err => console.log(err));
    },
    //Botones y Formularios
    guardar(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (this.operacion == "crear") this.crear();
          if (this.operacion == "editar") this.editar();
          this.modal = false;
          this.$refs[form].resetFields();
        } else {
          return false;
        }
      });
    },
    formNuevo() {
      this.modal = true;
      this.operacion = "crear";
      this.accion = "Guardar";
      this.tituloModal = "Nuevo Producto";
      this.form.nombre = "";
      this.form.multiplicable = true;
      if (typeof this.$refs.form != "undefined") {
        this.$refs.form.resetFields();
      }
    },
    formEditar(_, data) {
      //capturamos los datos del registro seleccionado y los mostramos en el formulario
      this.modal = true;
      this.operacion = "editar";
      this.accion = "Actualizar";
      this.tituloModal = "Editar Producto";
      this.form.id = data.id;
      this.form.nombre = data.nombre;
      this.form.multiplicable = data.multiplicable == "1" ? true : false;
      if (typeof this.$refs.form != "undefined") {
        this.$refs.form.clearValidate();
      }
    },
    // Paginación
    paginate(val) {
      this.page = val;
    },
  },
};
</script>

<style></style>
